import { render, staticRenderFns } from "./flightResult.vue?vue&type=template&id=364cefd4"
import script from "./flightResult.vue?vue&type=script&lang=js"
export * from "./flightResult.vue?vue&type=script&lang=js"
import style0 from "./flightResult.vue?vue&type=style&index=0&id=364cefd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports